<template>
  <div>
    <button
      type="button"
      class="btn -clear -hasIcon"
      @click="compartilhar"
      aria-label="Compartilhar"
    >
      <icon name="share" size="medium" class="-left -out"></icon>
      <span class="label" v-if="withLabel">Compartilhar</span>
    </button>
    <compartilhar-modal
      v-if="showModal"
      @close-modal="closeModal"
    ></compartilhar-modal>
  </div>
</template>

<script>
import CompartilharModal from "./modals/Compartilhar.vue";
export default {
  props: {
    withLabel: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    compartilhar() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  },
  components: {
    "compartilhar-modal": CompartilharModal
  }
};
</script>
